import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { PILOT_AUTH_STORAGE_KEY } from './authRouting';

const URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let cached: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (cached) return cached;
  if (!URL || !ANON) return null;
  cached = createClient(URL, ANON, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: PILOT_AUTH_STORAGE_KEY,
    },
  });
  return cached;
}

export function isBackendConfigured(): boolean {
  return Boolean(URL && ANON);
}
